const scrollingImageRows = document.querySelectorAll(
  '.scrolling-services-container'
);
scrollingImageRows.forEach((el, i) => {
  window.addEventListener('scroll', () => {
    const windowScrollTop =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const header = document.querySelector('.site-header');
    const scrollTop = windowScrollTop + header.offsetHeight;

    const container = el;
    const trackOuter = el.querySelector('.scrolling-services-wrapper');
    const track = el.querySelector('.scrolling-services');
    const trackWidth = track.offsetWidth;
    // const trackHeight = track.offsetHeight;
    const startX = trackWidth * -1;
    const endX = 0;

    const elTop = el.offsetTop;
    const elHeight = el.offsetHeight;
    const screenBottom = windowScrollTop + windowHeight;
    const elBottom = elTop + elHeight;
    let scrollPercentage;
    if (screenBottom <= elTop) {
      scrollPercentage = 0;
    } else {
      scrollPercentage = ((scrollTop - elTop) / elHeight) * 100;
    }
    const scrollPosition = (trackOuter.scrollWidth / 100) * scrollPercentage;
    console.log('scrollPercentage', scrollPercentage);

    const rangeX = endX - startX;
    const posX = (rangeX / 100) * scrollPercentage;

    if (scrollTop >= elTop && screenBottom < elBottom) {
      container.classList.add('is-scrolling');
      trackOuter.classList.add('is-scrolling');
    } else {
      container.classList.remove('is-scrolling');
      trackOuter.classList.remove('is-scrolling');
    }

    if (screenBottom >= elBottom) {
      container.classList.add('is-scrolled');
      trackOuter.classList.add('is-scrolled');
    } else {
      container.classList.remove('is-scrolled');
      trackOuter.classList.remove('is-scrolled');
    }

    // if (windowWidth >= 1000) track.style.transform = `translateX(${posX}px)`;
    // else track.style.transform = `translateX(0)`;

    trackOuter.scrollLeft = scrollPosition;
    // else track.style.transform = `translateX(0)`;
  });
});
